import {connect} from 'react-redux';
import React, {Component, Fragment} from 'react';
import {actions as label} from '../reducers/label';
import {actions as system} from '../reducers/system';
import {actions as labelCollection} from '../reducers/labelCollection';
import { actions as language} from '../reducers/language';
import Translation from "../components/Translation";
import Modal from "../components/general/Modal";
import _ from "lodash";
import {Link} from "react-router-dom";
import * as settings from "../services/settings";
import {actions as project} from "../reducers/project";

@connect(
	state => {
		return {
			selectedProject: state.project.selected,
			selectedLabelCollection: state.labelCollection.selected,
			labels: state.label.labels,
			hasUnsavedChanges: state.system.hasUnsavedChanges,
			loadingLanguages: state.language.loadingLanguages,
			clickedSaveLanguage: state.language.clickedSaveLanguage,
			highlightedLabel: state.label.highlighted,
            hasFilter: state.labelCollection.hasFilter
		}
	},
	dispatch => {
		return {
			fetchLabels: () => dispatch(label.fetch()),
			deleteLabel: labelObject => dispatch(label.delete(labelObject)),
			updateTranslation: (labelName, languageIdentifier, pluralKey, translation) => dispatch(label.updateTranslation(labelName, languageIdentifier, pluralKey, translation)),
			lockLanguage: languageIdentifier => dispatch(labelCollection.lockLanguage(languageIdentifier)),
			finishLanguage: languageIdentifier => dispatch(labelCollection.finishLanguage(languageIdentifier)),
			setHasUnsavedChanges: toggle => dispatch(system.setHasUnsavedChanges(toggle)),
			updateNoValueLabels: labelObject => dispatch(label.updateNoValueLabel(labelObject)),
			updateHighlightedLabel: labelToHighlight => dispatch(label.highlightLabel(labelToHighlight)),
            enableFilter: () => dispatch(labelCollection.enableFilter()),
            disableFilter: () => dispatch(labelCollection.disableFilter()),
            setClickedSaveLoading: (languageIdentifier) => dispatch(language.setClickedSaveLoading(languageIdentifier))
		};
	})
export default class LabelCollectionDetail extends Component {

	constructor(props) {
		super(props);

		this.labelRef = React.createRef();

		this.state = {
			hiddenLanguages: localStorage.getItem('hiddenLanguages') ? JSON.parse(localStorage.getItem('hiddenLanguages')) : [],
			selectedLabel: '',
            focusTranslation: ''
		};
	}

	componentDidMount() {
	    if(this.labelRef.current)
        {
            this.labelRef.current.scrollIntoView({behavior: "smooth", block: "center"})
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.labelRef.current)
        {
            let scrollTop = document.getElementsByClassName('card m-0')[0].scrollTop
            let scrollBottom = scrollTop + document.getElementsByClassName('card m-0')[0].clientHeight
            let offsetTop = this.labelRef.current.offsetTop;
            if(!(scrollTop < offsetTop && scrollBottom > offsetTop)) {
                if(prevProps.highlightedLabel !== this.props.highlightedLabel) {
                    this.labelRef.current.scrollIntoView({behavior: "smooth", block: "center"})
                }
            }
        }
    }

	componentWillReceiveProps(nextProps, nextContext) {
		if (
			nextProps.selectedLabelCollection !== null && (
				(this.props.selectedLabelCollection === null)
				||
				(nextProps.selectedLabelCollection.identifier !== this.props.selectedLabelCollection.identifier)
			)
		) {
			this.props.fetchLabels().then(() => {
                if(this.labelRef.current)
                {
                    this.labelRef.current.scrollIntoView({behavior: "smooth", block: "center"})
                }
            })
		}
	}

	getDefaultValueVariables(label) {
		if (label.defaultValue) {
			let matches = label.defaultValue.match(/{.*?}/g);
			return matches ? matches : [];
		}
		return [];
	}

	renderTranslationFields(label) {
		return _.map(this.visibleLanguages(), (language, key) => {
			const translations = _.get(label.translations, language.identifier);
			const isPlural = _.size(translations) > 1;
			const updateTranslation = (newTranslation) => {
                this.setState({focusTranslation: newTranslation})
            }
			return (
				<td key={language.identifier} className={'testcafe_lang_' + language.identifier}>
					{_.map(translations, (translation, pluralKey) => (
						<div key={pluralKey} className={_.isString(language.lockedBy) ? 'text-gray': ''}>
							{isPlural ? <span className="pluralKey">{pluralKey}</span> : null}
							<Translation
                                identifier={label.name + key}
								languageIndex={key}
								defaultValueVariables={this.getDefaultValueVariables(label)}
								lockedBy={language.lockedBy}
								translation={translation}
								noValue={label.noValue}
								allowMultiline={label.allowMultiline}
								update={(newValue) => this.props.updateTranslation(label.name, language.identifier, pluralKey, newValue)}
								setHasUnsavedChanges={toggle => {
									if(this.props.hasUnsavedChanges !== toggle){
										this.props.setHasUnsavedChanges(toggle);
									}
								}}
								updateSelected={() => this.props.updateHighlightedLabel(label)}
                                focusTranslation={this.state.focusTranslation}
                                updateFocusTranslation={updateTranslation}
                                disabled={this.props.clickedSaveLanguage.includes(language.identifier)}
							/>
						</div>
					))}
				</td>
			);
		});
	}

	toggleLanguage(languageIdentifier) {
		let newHiddenLanguages;
		if(_.includes(this.state.hiddenLanguages, languageIdentifier)){
			newHiddenLanguages = _.without(this.state.hiddenLanguages, languageIdentifier);
		} else {
			newHiddenLanguages = _.concat(this.state.hiddenLanguages, languageIdentifier);
		}
		this.setState({hiddenLanguages: newHiddenLanguages});
		localStorage.setItem('hiddenLanguages', JSON.stringify(newHiddenLanguages));
	}

	visibleLanguages() {
		return _.filter(this.props.selectedLabelCollection.languages, language => !_.includes(this.state.hiddenLanguages, language.identifier));
	}

	hiddenLanguages() {
		return _.filter(this.props.selectedLabelCollection.languages, language => _.includes(this.state.hiddenLanguages, language.identifier));
	}

	hasLabelTranslatedAll(label) {
		let hasFalse = false;
		_.map(this.visibleLanguages(), (language, key) => {
			if (label.translations[language.identifier] !== undefined && label.translations[language.identifier].one !== undefined)
			{
				if (label.translations[language.identifier].one.value === '') {
					hasFalse = true;
				}
			}else if (label.translations[language.identifier] !== undefined && label.translations[language.identifier].other !== undefined)
			{
				if (label.translations[language.identifier].other.value === '') {
					hasFalse = true;
				}
			}

		})
		return !hasFalse;
	}

	getFilteredLabels() {
		let labels = [];

		this.props.labels.map((label) => {
			if(!this.hasLabelTranslatedAll(label)) {
				labels.push(label);
			}
		});
		return labels;
	}


    updateFilter(isActive) {
        if (isActive) {
            this.props.enableFilter()
        }else {
            this.props.disableFilter()
        }
    }

	render() {
		return this.props.selectedLabelCollection && this.props.labels.length ? (
			<Fragment>
				<Link to={'/show/' + this.props.selectedProject.name}><button title="back" className="btn btn-secondary">Back</button></Link>
				<small>{this.props.selectedLabelCollection.identifier}</small>
				<div style={{overflow: "auto", 'height': 'calc(100vh - 200px)'}} className="card m-0" onMouseDown={(event) => event.target.type!=='textarea'?this.setState({focusTranslation: ''}):null}>
					<div className="card-body" style={{'paddingTop': '0px'}}>
						<div className="text-right">
							{_.map(this.hiddenLanguages(), (language, key) => (
								<button className="btn" key={key}
										onClick={() => this.toggleLanguage(language.identifier)}>
									{language.identifier}
								</button>
							))}
						</div>

						<div>
							<table className="table table-fixed">
								<thead>
								<tr>
									<th style={{'position': 'sticky', 'top': '0px', 'backgroundColor': 'white', 'zIndex': '999'}}>Name</th>
									<th style={{'position': 'sticky', 'top': '0px', 'backgroundColor': 'white', 'zIndex': '999'}}>Default Value</th>
									{_.map(this.visibleLanguages(), (language, key) => (
										<th style={{'position': 'sticky', 'top': '0px', 'backgroundColor': 'white', 'zIndex': '999'}} key={key} className={'testcafe_lang_' + language.identifier}>
											{language.identifier}
											<i title="hide" className="fa fa-eye-slash ml-1"
											   onClick={() => this.toggleLanguage(language.identifier)}/>
										</th>
									))}
									<th style={{'position': 'sticky', 'top': '0px', 'backgroundColor': 'white', 'zIndex': '999'}}></th>
									<th style={{'position': 'sticky', 'top': '0px', 'backgroundColor': 'white', 'zIndex': '999'}}></th>
								</tr>
								<tr>
									<td style={{'position': 'sticky', 'top': '45px', 'backgroundColor': 'white', 'zIndex': '999'}} className={"border-top-0"}>
										<input type='checkbox' checked={this.props.hasFilter} onChange={(event) => {
                                            this.updateFilter(event.target.checked)
										}}/>
										Hide fully translated labels
									</td>
									<th style={{'position': 'sticky', 'top': '45px', 'backgroundColor': 'white', 'zIndex': '999'}}></th>
									{_.map(this.visibleLanguages(), (language, key) => {
										if (language.lockedBy === true) {
											return (<th style={{'position': 'sticky', 'top': '45px', 'backgroundColor': 'white', 'zIndex': '999'}} key={key} className={"testcafe_lang_" + language.identifier}>
												<button disabled={this.props.hasUnsavedChanges}
														className="btn btn-primary"
														onClick={() => {
														    if(this.props.loadingLanguages.includes(language.identifier)){
                                                                this.props.setClickedSaveLoading(language.identifier)
                                                            }else {
                                                                this.props.finishLanguage(language.identifier)
                                                            }

                                                        }}>Save
												</button>
											</th>);
										}

										if (language.lockedBy === false) {
											return (<th style={{'position': 'sticky', 'top': '45px', 'backgroundColor': 'white', 'zIndex': '999'}} key={key} className={"testcafe_lang_" + language.identifier}>
												<button className="btn btn-primary"
														onClick={() => this.props.lockLanguage(language.identifier)}>Edit
												</button>
											</th>);
										}

										return (<th style={{'position': 'sticky', 'top': '45px', 'backgroundColor': 'white', 'zIndex': '999'}} key={key}>
											Locked by {language.lockedBy}
										</th>);
									})}
									<th style={{'position': 'sticky', 'top': '45px', 'backgroundColor': 'white', 'zIndex': '999'}} ></th>
									<th style={{'position': 'sticky', 'top': '45px', 'backgroundColor': 'white', 'zIndex': '999'}} ></th>
								</tr>
								</thead>
								<tbody id='table-body'>
								{
									_.map(!this.props.hasFilter?this.props.labels:this.getFilteredLabels(), (label, labelKey) => (
										// eslint-disable-next-line no-useless-concat
										<tr
											ref={this.props.highlightedLabel && this.props.highlightedLabel.name === label.name ? this.labelRef : null}
											id={label.name}
											key={labelKey}
											className={'testcafe-labelname-' + label.name.replace(/\./g, '-')} onClick={() => this.props.updateHighlightedLabel(label)}
											style={this.props.highlightedLabel && this.props.highlightedLabel.name === label.name ? {'backgroundColor': '#ffc0a4'} : null}>
											<td className={this.props.highlightedLabel && this.props.highlightedLabel.name === label.name ? null :  'text-gray'}>
												<div style={{maxWidth: 300}}>{label.name}</div>
											</td>
											<td className={this.props.highlightedLabel && this.props.highlightedLabel.name === label.name ? null :  'text-gray'}>{label.defaultValue}</td>
											{this.renderTranslationFields(label)}
											<td>
												<div className="form-check">
													<label title="no translation needed"
														   style={label.disallowEmpty ? {opacity: 0.3} : null}
														   className={"form-check-label"}>
														<input className={"form-check-input"}
															   style={label.disallowEmpty ? {opacity: 1} : null}
															   disabled={label.disallowEmpty} checked={label.noValue}
															   onChange={() => this.props.updateNoValueLabels(label)}
															   type={"checkbox"}/>
														<span className="form-check-sign"/>
													</label>
												</div>
											</td>
											{settings.showAdminFunctions() ? (
												<td>
													<Link
														to={'/edit/' + encodeURIComponent(this.props.selectedProject.name) + '/' + encodeURIComponent(this.props.selectedLabelCollection.identifier) + '/' + encodeURIComponent(label.name)}
														className="btn btn-link btn-icon btn-sm edit"
														title="edit">
														<i className="fa fa-edit"/>
													</Link>
													<button className="btn btn-danger btn-link btn-icon btn-sm"
															data-target={'#delete-label-' + labelKey}
															data-toggle="modal"
															title="delete">
														<i className="fa fa-times"/>
													</button>

													<Modal
														identifier={'delete-label-' + labelKey}
														callBack={() => this.props.deleteLabel(label)}
														text={'Delete label "' + label.name + '" ?'}
														title="Danger Zone"
														actionText="Delete"
														dismissText="Cancel"
													/>
												</td>
											) : null}
										</tr>
									))
								}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</Fragment>
		) : null
	}
}



// WEBPACK FOOTER //
// ./React/src/screens/LabelCollectionDetail.js